import {
    FetchState
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import {
    SalesPersonState,
    SalesPerson
} from "@/admin/types";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";
import { defineStore } from "pinia";

export const initialState: SalesPersonState = {
    getRequestFetchState: FetchState.Uninitialized,
    postRequestFetchState: FetchState.Uninitialized,
    salesPersons: []
};


export const useSalesPersonStore = defineStore("salesPerson", {
    state: (): SalesPersonState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.getRequestFetchState === FetchState.Loaded,
        isPosting: state => state.postRequestFetchState === FetchState.Loading,
        activeSalesPersons: (state): SalesPerson[] => _.filter(state.salesPersons, { isActive: true }),
        salesPersonById: state => (salesPersonId: number) => {

            if (!state.salesPersons.length) {
                return null;
            }

            return _.find(state.salesPersons, salesPerson => salesPerson.salesPersonId === salesPersonId);
        }
    },
    actions: {
        setGetRequestFetchState (fetchState: FetchState) {
            this.getRequestFetchState = fetchState;
        },
        setPostRequestFetchState (fetchState: FetchState) {
            this.postRequestFetchState = fetchState;
        },
        setSalesPersons (salesPersons: SalesPerson[]) {
            this.salesPersons = [ ...salesPersons ];
        },
        resetState () {
            this.getRequestFetchState = FetchState.Uninitialized;
            this.salesPersons = [];
        },
        getSalesPersons (forceRefresh = false) {
            return new Promise<void>((resolve, reject) => {
                if (forceRefresh) {
                    this.resetState();
                }
                if (this.getRequestFetchState !== FetchState.Uninitialized) {
                    resolve();
                    return;
                } else {
                    this.setGetRequestFetchState(FetchState.Loading);
                    return UserService.getSalesPersons().then(resp => {
                        this.setSalesPersons(resp.data);
                        this.setGetRequestFetchState(FetchState.Loaded);
                    }).catch(err => {
                        storeHelper.handleError({ error: err, rethrow: true });
                    });
                }
            });
        },
        saveSalesPerson (salesPerson: SalesPerson | object) {
            return new Promise<void>((resolve, reject) => {
                if (this.postRequestFetchState === FetchState.Loading) {
                    resolve();
                    return;
                } else {
                    this.setPostRequestFetchState(FetchState.Loading);
                    return UserService.saveSalesPerson(salesPerson).then(resp => {
                        this.setPostRequestFetchState(FetchState.Loaded);
                        const notifierStore = useNotifierStore();
                        notifierStore.setSuccess(`The sales person has been added.`);
                        this.getSalesPersons(true);
                    }).catch(err => {
                        storeHelper.handleError({ error: err, rethrow: true });
                    });
                }
            });
        }
    }
});